import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import classes from './CustomerNetwork.css';
import Box from '../../hoc/Box/Box';
import api from '../../axios-local-api';
import * as actions from '../../store/actions/index';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import Spinner from '../../components/UI/Spinner/Spinner';
import Router from '../Router/Router';
import Pod from '../Pod/Pod';
import Modem from '../Modem/Modem';
import Confirm from '../../components/UI/Confirm/Confirm';
import Success from '../../components/UI/Success/Success';
import Error from '../../components/UI/Error/Error';
import Modal from '../../components/UI/Modal/Modal';
import { FaExclamationCircle, FaArrowUp, FaArrowDown } from 'react-icons/fa';
import { FaDownload, FaSync } from 'react-icons/fa';
import { withRouter } from 'react-router-dom';
import { history } from '../..';
import { EquipmentTypes } from '../../shared/common';

export class CustomerNetwork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      success: false,
      error: false,
      action: null,
      result: null,
      confirmModal: false,
      loading: false,
      multiLoaded: false,
      modem: { model: 'N/A' }
    };
  }

  componentDidMount() {
    this.setState({ modem: { model: this.props?.data?.modems?.[0]?.model}});
    this.props.data.setEquipmentSelection({
      displayAllEquipment: true,
      type: EquipmentTypes.Equipment,
    });
  }
  componentWillUpdate() { }
  componentDidUpdate() {
    if (!this.state.multiLoaded && this.props.multiRouter && this.props.multiRouter && this.props.multiRouter.networkTopology) {
      let tempModems = this.props.multiRouter?.networkTopology?.find((item) => {
        let mac = sessionStorage.getItem("mac")
        if ((item.modem && item.router && (item?.router?.mac.toLowerCase() === mac.toLowerCase())) ||
          ((item.modem && (sessionStorage.getItem("multi") === "false" || sessionStorage.getItem("multi") === false) && !sessionStorage.getItem('type')?.includes('Business')))) {
          this.setState({
            modem: item.modem,
          });
        }
      });
      this.setState({
        multiLoaded: true
      });

    }
  }
  redirectToEquipmentpage = () => {
    this.props.data.setEquipmentSelection({
      displayAllEquipment: true,
      type: EquipmentTypes.Equipment,
      didClick: true,
    });
    this.props.history.push('/overview');
  };
  onClick = () => {
    this.props.data.setEquipmentSelection({
      displayAllEquipment: true,
    });
  };

  hasAnyDisconnectedPods = (router) => {
    let disconnectedPods = [];
    if (router.pods !== undefined) {
      router.pods.forEach((pod) => {
        this.findDisconnectedPods(disconnectedPods, pod);
      });
    }
    // console.log('found disconnected pods', disconnectedPods);
    return disconnectedPods.length > 0;
  };

  findDisconnectedPods = (acc, pod) => {
    if (pod === undefined) {
      return;
    }
    if (
      pod.connectionState !== undefined &&
      pod.connectionState === 'disconnected'
    ) {
      acc.push(pod);
    }
    if (pod.pods === undefined) {
      return;
    }
    pod.pods.forEach((p) => {
      this.findDisconnectedPods(p);
    });
  };

  confirmModalConfirmHandler = () => {
    if (this.state.action === 'Reboot all equipment?') {
      this.props.onRebootRouter(true);
      this.setState({ loading: true });
    }
    this.closeModal();
  };

  confirmModalCancelHandler = () => {
    this.setState({ confirmModal: false });
  };

  successErrorResetHandler = () => {
    this.setState({ error: false, success: false });
    this.props.onResetSettingsErrorSuccess();
  };

  closeModal = () => {
    this.setState({ confirmModal: false });
  };

  onOpenModal = (result, action) => {
    this.setState({
      confirmModal: true,
      result: result,
      action: action,
    });
  };

  rebootHandler = () => {
    this.onOpenModal(
      'This will interrupt connectivity for a few minutes.',
      'Reboot all equipment?'
    );
  };

  render() {
    // console.log('CustomerNetwork.render()', this.props, 'state', this.state);
    if (this.props.error && !this.state.error) {
      this.setState({ error: true, loading: false });
      this.props.onResetSettingsErrorSuccess();
    }
    if (this.props.success && !this.state.success) {
      this.setState({ success: true, loading: false });
      this.props.onResetSettingsErrorSuccess();
    }

    let equips;
    if (this.props.loading) {
      return <Spinner />;
    } else {
      let routers = this.props.data.routers.map((router) => {
        return (
          <Router
            key={Math.floor(Math.random() * 10000)}
            data={router}
            selectedEquipment={this.props.data.selectedEquipment}
          />
        );
      });
// console.log('sessionStorage ::::', sessionStorage);
      let unclaimedPods = this.props.data.unclaimedPods.map((pod) => {
        return (
          <Pod
            key={Math.floor(Math.random() * 10000)}
            data={pod}
            selectedEquipment={this.props.data.selectedEquipment}
          />
        );
      });


      let hasAnyDisconnectedPods = this.hasAnyDisconnectedPods(
        this.props.data.routers[0]
      );
      let disconnectionAlert;
      if (
        this.props.checkingWan ||
        (this.props.podTimer && this.props.rebootPodId) ||
        hasAnyDisconnectedPods ||
        this.props.data.routers[0].connectionState !== 'connected'
      ) {
        disconnectionAlert = <FaExclamationCircle color={'red'} />;
      }

      let allEquipHtml;
      if (
        this.props.data.selectedEquipment &&
        this.props.data.selectedEquipment.displayAllEquipment
      ) {
        allEquipHtml = (
          <div
            id='AllEquipment'
            className={[classes.Equipment, classes.SelectedBgColor].join(' ')}
            style={{
              padding: '5px 10px 5px 5px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'baseline',
            }}
          >
            <div
              style={{ width: '100%', padding: 20, cursor: 'pointer' }}
              onClick={this.redirectToEquipmentpage}
            >
              <b>All Equipment</b> {disconnectionAlert}{' '}
            </div>

            <FaSync
              id='refreshBtn'
              style={{ color: '#0073d1' }}
              onClick={() => {
                this.props.refreshButtonClicked();
                this.props.onGetPropertyManagerDetails();
                this.props.onInitWan();
                this.props.onInitEquipment();
                this.props.onRefreshDevices(this.props.selectedEquipment);
              }}
            />
          </div>
        );
      } else {
        allEquipHtml = (
          <div
            className={[classes.Equipment]}
            style={{
              padding: '5px 10px 5px 5px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'baseline',
            }}
          >
            <div
              style={{ width: '100%', padding: 20, cursor: 'pointer' }}
              onClick={this.redirectToEquipmentpage}
            >
              <b>All Equipment</b> {disconnectionAlert}{' '}
            </div>

            <FaSync
              style={{ color: '#0073d1' }}
              onClick={() => {
                // console.log('CLICKABLE');
                this.props.refreshButtonClicked();
                this.props.onGetPropertyManagerDetails();
                this.props.onInitWan();
                this.props.onInitEquipment();
                this.props.onRefreshDevices(this.props.selectedEquipment);
              }}
            />
          </div>
        );
      }
      return (
        <Box>
          <div className={classes.Spacer} />

          {/* <div className={classes.Equipment} onClick={this.redirectToEquipmentpage}>
          <b>All Equipment</b>
          </div> */}
          {allEquipHtml}
          <div className={classes.Router} key='Routers'>{routers}</div>
          {!sessionStorage.getItem('type')?.includes('Business') && sessionStorage.getItem("multi") !== "true" &&
          <div className={classes.Router} key='UnClaminedPods'>{unclaimedPods}</div> }
          <div className={classes.Spacer}key='RebootAll' />
          <div>
            <button
              id='rebootall'
              className={classes.Button}
              onClick={this.rebootHandler}
              title={
                this.props.firmwareDisplayUpdateSpinner
                ? 'Please wait until Firmware Update has completed' :
                this.props.optimizeRouterDisplayUpdateSpinner ? 'Please wait until Network Optimization has completed' : ''
              }
              disabled={
                (this.props.checkingWan && this.props.timerStart) ||
                !this.props.realWan ||
                this.props.realWan === null ||
                (this.props.wan?.loaded && this.props.realWan?.connectionState === 'disconnected') ||
                this.props.firmwareDisplayUpdateSpinner ||
                this.props.realWan.connectionState !== 'connected' ||
                this.props.isSteering ||
                this.props.optimizeRouterDisplayUpdateSpinner
              }
            >
              Reboot All
            </button>
          </div>
          <div>{[<Modem data={this.state.modem} />]}</div>
          <Modal show={this.state.confirmModal} modalClosed={this.closeModal}>
            <Confirm
              id='CustomerNetworkConfirm'
              action={this.state.action}
              result={this.state.result}
              confirm={this.confirmModalConfirmHandler}
              cancel={this.confirmModalCancelHandler}
              deviceGroupConfirmation
            />
          </Modal>
          <Modal
            show={this.state.error}
            modalClosed={this.successErrorResetHandler}
          >
            <Error id={'CustomerNetworkError'} />
          </Modal>
          <Modal
            show={this.state.success}
            modalClosed={this.successErrorResetHandler}
          >
            {/* parentComponent='CustomerNetwork' */}
            <Success id={'CustomerNetworkSuccess'} />
          </Modal>
        </Box>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.settings.loading,
    loaded: state.settings.loaded,
    account: state.settings.account,
    realEquipment: state.equipment.realEquipment,
    realSettings: state.settings.realSettings,
    realWan: state.wan.realWan,
    checkingWan: state.wan.checkingWan,
    timerStart: state.wan.timerStart,
    podTimer: state.wan.podTimer,
    rebootPodId: state.wan.rebootPodId,
    multiRouter: state.multiRouter.multiRouter,
    isSteering: (state.devices.realDevices || []).some(
      (d) =>
        d.steering &&
        d.steering.forced &&
        d.steering.forced.expiresAt &&
        moment().isBefore(moment(d.steering.forced.expiresAt))
    ),
    firmwareDisplayUpdateSpinner: state.settings.firmwareDisplayUpdateSpinner,
    optimizeRouterDisplayUpdateSpinner: state.settings.optimizeRouterDisplayUpdateSpinner
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRebootRouter: (all) => dispatch(actions.rebootRouter(all, false)),
    onResetSettingsErrorSuccess: () =>
      dispatch(actions.resetSettingsErrorSuccess()),
    onInitEquipment: () => dispatch(actions.initEquipment()),
    onInitWan: () => dispatch(actions.initWan()),
    onRefreshDevices: (selectedEquipment) =>
      dispatch(actions.refreshDevices(selectedEquipment)),
    onGetPropertyManagerDetails: () => dispatch(actions.getPropertyManagerDetails(true)),
    onGetPropertyManagerTenantDetails: (filter, search, page, size) => dispatch(actions.getPropertyManagerTenantDetails(filter, search, page, size)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withErrorHandler(CustomerNetwork, api))
);
